// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__3kRR3","dark":"Footer_dark__10s62"};